const translations = {
  "en": {
    "Please refresh the page.": "Please refresh the page.",
    "Refresh": "Refresh",
    "Something Went Wrong": "Something Went Wrong"
  },
  "zh-tw": {
    "Please refresh the page.": "請重新整理頁面。",
    "Refresh": "重新整理",
    "Something Went Wrong": "發生錯誤"
  }
};

export default translations;
